import { render } from "./ContactsList.vue?vue&type=template&id=67f0f860&ts=true"
import script from "./ContactsList.vue?vue&type=script&lang=ts"
export * from "./ContactsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__